(() => {
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-delivery-checkout]');
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    const notice = link.closest('.product__delivery-notice');
    const error = notice.querySelector('[data-delivery-checkout-error]');
    const showError = (message) => {
      error.textContent = message;
      error.hidden = false;
    };
    error.hidden = true;
    const form = document.getElementById(link.dataset.productFormId);
    const variant = form?.querySelector('[name="id"]');
    if (!form || !variant || variant.disabled || !variant.value) {
      showError(link.dataset.variantError);
      return;
    }
    if (!form.reportValidity()) return;
    const data = new FormData(form);
    if (!data.has('quantity')) data.set('quantity', '1');
    link.setAttribute('aria-busy', 'true');
    link.setAttribute('aria-disabled', 'true');
    try {
      const response = await fetch(link.dataset.cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data,
        credentials: 'same-origin'
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        showError(result.description || result.message || link.dataset.errorMessage);
        return;
      }
      window.location.assign(link.dataset.checkoutUrl);
    } catch (failure) {
      showError(link.dataset.errorMessage);
    } finally {
      link.removeAttribute('aria-busy');
      link.removeAttribute('aria-disabled');
    }
  });
})();
